<template>
<div class="footer">
    <div class="wrapper">
        <div class="footer-nav">
            <div class="footer-title">导航</div>
            <a href="/">首页</a>
            <a href="/buy.htm">我要买车</a>
            <a v-for="item in navList" :href="item.url" :target="item.target">{{ item.text }}</a>
        </div>
        <div class="footer-intro">
            <div class="footer-title">联系方式</div>
            <div class="content">联系电话：{{ addressCall }}</div>
            <div class="content">
                <div class="content-title">通讯地址：</div>
                <div class="content-body">
                    <template v-for="item in addressList">
                        <div class="content-body-list">{{ item }}</div>
                    </template>
                </div>
            </div>
        </div>
        <div class="footer-links">
            <div class="footer-title">友情链接</div>
            <a href="//www.souche.com/" target="_blank">大搜车</a>
            <template v-for="item in friendLinkList">
                <a :href="item.url" :target="item.target">{{ item.text }}</a>
            </template>
        </div>
        <div class="qr-code" v-if="qrImgSrc">
            <div class="footer-title">微信号</div>
            <img :src="qrImgSrc">
        </div>

        <div class="announcement">
           <div class="announcement__text">
               <template v-for="(item, index) in announcementText">
                   <span v-if="index != 0">|</span>
                   <a :href="formatUrl(item.url)">
                       {{ item.text }}
                   </a>
                </template>
            </div>
            <div class="announcement__image">
                <template v-for="item in announcementImage">
                <a :href="formatUrl(item.url)">
                    <img :src="'//img.souche.com/' + item.image" :title="item.text" :alt="item.text">
                </a>
                </template>
           </div>
           <div class="other">
               <a href="/?__mobile=true">进入手机版</a>
           </div>
       </div>
   </div>
</div>
</template>

<script>
import imgUrl from 'babel!@souche-f2e/chunyan-util/img-util/url-util';
export default {
    computed: {
        navList() {
            return window._qiwa.site_global.index_bottom_nav;
        },
        announcementText() {
            var ret = [];
            this.arg0.forEach(function(v) {
                if (!v.image) {
                    ret.push(v);
                }
            });
            return ret;
        },
        announcementImage() {
            var ret = [];
            this.arg0.forEach(function(v) {
                if (v.image) {
                    ret.push(v);
                }
            });
            return ret;
        },
        arg0() {
            return window._qiwa.site_global.annoncementList;
        },
        addressCall() {
            if (window._qiwa.__basic_site_default_shop.addresscall) {
                return window._qiwa.__basic_site_default_shop.addresscall;
            } else if (window._qiwa.__basic_site_default_shop.phone) {
                return window._qiwa.__basic_site_default_shop.phone;
            }
        },
        qrImgSrc() {
            return window._qiwa.site_global.shop_weixin_QR_code? imgUrl.formatUrl(window._qiwa.site_global.shop_weixin_QR_code, 160, 160): '';
        },
        addressList() {
            return window._qiwa.site_global.default_address_list;
        },
        friendLinkList() {
            return window._qiwa.site_global.common_friend_links;
        }
    },
    methods: {
        formatUrl(url) {
            if (!url) {
                return false;
            }
            if (url.indexOf('http://') !== 0 && url.indexOf('https://') !== 0 && url.indexOf('/') !== 0) {
                url = `//${url}`;
            }
            return url;
        }
    }
};
</script>

<style lang="less" scoped>
.footer {
    background: #22211f;
    width: 100%;
    padding-top: 50px;
    .wrapper {
        width: 1280px;
        margin: 0 auto;
        position: relative;

        .footer-title {
            color: #fff;
            text-decoration: none;
            font-size: 14px;
            font-family: 'Microsoft YaHei';
            line-height: 14px;
            display: block;
            height: 15px;
            margin-bottom: 16px;
            font-weight: bold;
        }
        .footer-nav {
            width: 150px;
            float: left;
            padding-left: 7px;
            a {
                color: #bbb;
                text-decoration: none;
                font-size: 14px;
                font-family: 'Microsoft YaHei';
                line-height: 14px;
                display: block;
                height: 15px;
                margin-bottom: 16px;
            }
        }
        .footer-intro {
            width: 900px;
            height: 238px;
            border-left: #4a4a4a 1px solid;
            float: left;
            padding-left: 65px;
            .content {
                color: #bbb;
                font-size: 14px;
                font-family: 'Microsoft YaHei';
                line-height: 15px;
                height: 15px;
                margin-bottom: 16px;
            }
            .content-title {
                float: left;
            }
            .content-body {
                float: left;
                height: 160px;
                overflow-y: auto;
                width: 560px;
            }
            .content-body-list {
                margin-bottom: 16px;
            }
        }
        .footer-links {
            clear: both;
            border-top: #4a4a4a 1px solid;
            position: relative;
            top: 10px;
            margin-bottom: 10px;
            .footer-title {
                float: left;
                padding: 0 10px;
                height: 30px;
                line-height: 30px;
                margin-bottom: 0;
            }
            a {
                color: #bbb;
                font-size: 12px;
                font-family: 'Microsoft YaHei';
                line-height: 30px;
                height: 30px;
                text-decoration: none;
                display: block;
                float: left;
                padding: 0 10px;
            }
            &:after {
                content: '';
                display: block;
                clear: both;
            }
        }
        .qr-code {
            height: 238px;
            width: 160px;
            border-left: #4a4a4a 1px solid;
            position: absolute;
            top: 0;
            right: 100px;
            padding-left: 50px;
            background: #22211F;
            img {
                width: 160px;
            }
        }
        .copyright {
            // position: absolute;
            // bottom: 0;
            // left: 0;
            clear: both;
            width: 1180px;
            height: 68px;
            border-top: #4a4a4a 1px solid;
            color: #bbb;
            font-size: 14px;
            line-height: 50px;
            a {
                text-decoration: none;
                color: #bbb;
                img {
                    vertical-align: middle;
                }
            }
            .powered-by {
                float: right;
            }
        }
    }
}

// 底部备案信息
.announcement {
    padding-top: 8px;
    height: 162px;
    border-top: #4a4a4a 1px solid;
    .announcement__text {
        span {
            color: #bbb;
            font-size: 12px;
        }
        a {
            color: #bbb;
            font-size: 12px;
            text-decoration: none;
        }
    }
    .announcement__image {
        margin-top: 8px;
        height: 32px;
        img {
            height: 100%;
            margin-right: 16px;
        }
    }
    .other {
        position: absolute;
        bottom: 20px;
        right: 0;
        a {
            color: #bbb;
            font-size: 14px;
            text-decoration: none;
        }
    }
}
</style>



// WEBPACK FOOTER //
// Default.vue?199d8cd2